<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense elevation="1" rounded color="secondary">
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Purchasing & Ordering'}, {text: 'Ordering'} ,{text: 'Edit Supplier Contact',}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Edit Contact
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave"/>
                            <PIconBtn icon="mdi-cancel" tooltip="Discard" @click="handleDiscard"/>
                            <PIconBtn icon="mdi-delete" tooltip="Delete" @click="handleDelete" v-if="hasPermission(perm.supplier_contact.delete)"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <SupplierContactForm class="ma-3" ref="form" v-if="!supplierLoading" v-model="data" />
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
        <LoadingOverlay :value="loading || supplierLoading"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PIconBtn from '../../components/common/PIconBtn.vue';
import PAlert from './../../components/common/PAlert.vue';
import LoadingOverlay from './../../components/common/LoadingOverlay.vue';
import SupplierContactForm from '../../components/purchase/SupplierContactForm.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "SupplierAccountEditView",
    components: {
        SupplierContactForm,
        PAlert,
        LoadingOverlay,
        PIconBtn
    },
    data() {
        return {
            id: null,
            data: null,
            alert: {
                title: "Alert",
                content: "Are you sure",
                value:  false,
                callback: null
            },
            loading: false,
            supplierLoading: false,
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "purchase/supplierContact/findByID",
            pushSupplier: "purchase/supplier/push",
            snackbar: "ui/snackbar/show",
            update: "purchase/supplierContact/update",
            remove: "purchase/supplierContact/remove",
        }),
        handleSave() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to save", callback: this.save}
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.update(this.data).then(response => {
                this.snackbar({ text: "Supplier Contact Created", color: "success"})
                this.$router.push({ name: "SupplierContactDisplay", params: { id: response.data.id}})
            }).catch(error => {
                let message = error.response? error.response.data.message : error;
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.loading = false;
            })
        },
        handleDiscard() {
            this.$router.back()
        },
        fetchSupplierContact() {
            this.supplierLoading = true;
            this.findByID(this.id).then(response => {
                this.pushSupplier(response.data.supplier)
                this.data = {...response.data}
                this.data.supplier_id = this.data.supplier ? this.data.supplier.id : null;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.supplierLoading = false
            })
        },
        handleDelete() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to remove contact?", callback: this.deleteAsync };
        },
        deleteAsync() {
            this.loading = true;
            this.remove(this.data).then(() => {
                this.snackbar({color: "success", text: "Supplier Removed Successfully."});
                this.$router.push({ name: "SupplierDisplay", params: { id: this.data.supplier_id }});
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message})
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    mounted() {
        this.id = this.$route.params.id 
        this.fetchSupplierContact()
    },
    beforRouteUpdate(from, to, next) {
        this.id = to.params.id;
        this.fetchSupplierContact();
        next()
    }

}
</script>

<style>

</style>